export const SET_EMAIL_CONFIRMATION = 'emailconfirmation/SET_EMAIL_CONFIRMATION';
export const SET_TITLE_CONFIRMATION = 'emailconfirmation/SET_TITLE_CONFIRMATION';
export const SET_BUTTON_CONFIRMATION = 'emailconfirmation/SET_BUTTON_CONFIRMATION';
export const SET_LOGIN_MODAL = 'emailconfirmation/SET_LOGIN_MODAL';
export const SET_RE_SEND_EMAIL_CONFIRMATION = 'emailconfirmation/SET_RE_SEND_EMAIL_CONFIRMATION';
export const POST_EMAIL_CONFIRMATION = 'saga/emailconfirmation/POST_EMAIL_CONFIRMATION';
export const POST_RE_SEND_EMAIL_CONFIRMATION = 'saga/emailconfirmation/POST_RE_SEND_EMAIL_CONFIRMATION';
